export default __webpack_public_path__ + "static/media/AFL iD Profile Background.08472eed.jpg";